export default __webpack_public_path__ + "blog01.jpg";